// @ts-nocheck

import * as React from 'react';
type Props = {
  /**
   * This function will toggle the input type on the Password input field so it shows or hides the input.
   */
  onShowHide?: () => void;

  /**
   * This is the value set in Input component state which indicates if show/hide toggle is on/off.
   */
  showPassword?: boolean | null | undefined;
};

class PasswordShowHide extends React.PureComponent<Props> {
  render() {
    return (
      <div className="show-hide-container" onClick={this.props.onShowHide}>
        {!!this.props.showPassword ? (
          <i className="material-icons show-hide visible" data-testid="show-hide-visible">
            visibility
          </i>
        ) : (
          <i className="material-icons show-hide" data-testid="show-hide-not-visible">
            visibility_off
          </i>
        )}
        <span className="show-hide-label">Show</span>
      </div>
    );
  }
}

export default PasswordShowHide;
